import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/ship-to-storage.jpg'),
    alt: 'ship to storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'ship to storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Hassle-Free <span>& Convenient</span><span>Ship to Storage Solutions</span>',
  description:
    'ShipAndStorage offers hassle-free Ship To Storage services for individuals and businesses, ensuring secure and efficient storage for all your items with flexible solutions and fast service.',
  points: [
    'Up to 6 Months Free Storage',
    'Free Insurance up to $250',
    '1 Small Box To 100 Large Box Storage',
    'Storage Services With Freedom'
  ],
  image: {
    url: '/images/v2/pages/landing-pages/ship-to-storage/hero-image.svg',
    alt: 'ship to storage page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for Storage Solutions' }
}

export const helperGuideSection = {
  title: 'How Secure Ship To Storage Services',

  ctaButton: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Learn More' },
  cards: [
    {
      id: 1,
      title: 'Choose Your Service Online',
      description:
        'Begin by selecting the shipping or storage service that fits your needs. You’ll receive an instant quote, and with a few quick steps, your booking is complete.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/choose-your-service-online.svg',
        alt: 'Choose Your Service Online service'
      }
    },
    {
      id: 2,
      title: 'Convenient Pickup & Safe Storage',
      description:
        'We’ll come directly to your location to pick up your items. They’ll be securely stored in our cutting-edge storage facilities with advanced safety protocols.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/convenient-pickup-and-safe-storage.svg',
        alt: 'Convenient Pickup & Safe Storage service'
      }
    },
    {
      id: 3,
      title: 'Delivery When You Need It',
      description:
        'Need your items back? Schedule a delivery at your convenience, and we’ll promptly ship your belongings to your location with care.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/delivery-when-you-need-it.svg',
        alt: 'Delivery When You Need It service'
      }
    },
    {
      id: 4,
      title: 'Fast and Secure Storage Shipping',
      description:
        "ShipAndStorage ensures your items are stored and shipped with speed and door-to-Door Convenience. Through our trusted global carriers like FedEx, DHL, and UPS, we guarantee fast delivery and safe storage. Whether you're moving, studying abroad, or need temporary storage, our services cater to your needs with timely pickups, secure packaging, and real-time tracking.",
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/fast-and-secure-storage-shipping.svg',
        alt: 'Fast and Secure Storage Shipping service'
      }
    }
  ]
}

export const whyConsiderSectionContent = {
  title: 'Why Consider Storage Solutions?',

  cards: [
    {
      id: 1,
      title: 'Optimize Your Space',
      description:
        'Free up room at home or work by storing items you don’t use daily, creating a neat, uncluttered area.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/optimize-your-space.svg',
        alt: 'Optimize Your Space'
      }
    },
    {
      id: 2,
      title: 'Support for Moving Needs',
      description: 'Make moves less stressful by storing essentials temporarily until you’re ready to settle in.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/support-for-moving-needs.svg',
        alt: 'Support for Moving Needs'
      }
    },
    {
      id: 3,
      title: 'Keep Seasonal Items Safe',
      description:
        'Store decorations, sports gear, and other items securely until their next use, for as long as needed.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/keep-seasonal-items-safe.svg',
        alt: 'Keep Seasonal Items Safe'
      }
    }
  ]
}

export const gridSectionContent = {
  title: 'Who Should Consider Ship to Storage Service?',
  description:
    'Our Ship to Storage service is designed for customers seeking a hassle-free way to store items directly from their location, whether for short or extended periods. ',

  cards: [
    {
      id: 1,
      title: 'Frequent Travelers',
      description: 'Secure storage for belongings while abroad, ensuring peace of mind.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/frequent-travelers.svg',
        alt: 'Frequent Travelers'
      }
    },
    {
      id: 2,
      title: 'Immigrants',
      description: 'Conveniently ship items to storage during transitions between locations.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/immigrants.svg',
        alt: 'Immigrants'
      }
    },
    {
      id: 3,
      title: 'Students',
      description: 'Easy storage for items between home and school without the hassle of transport.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/students.svg',
        alt: 'Students'
      }
    },

    {
      id: 4,
      title: 'Seasonal Movers',
      description: 'Flexible, short-term storage solutions for those needing temporary space.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/seasonal-movers.svg',
        alt: 'Seasonal Movers'
      }
    },
    {
      id: 5,
      title: 'E-commerce Sellers',
      description: 'Manage excess inventory effortlessly without long-term commitments.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/e-commerce-sellers.svg',
        alt: 'E-commerce Sellers'
      }
    },
    {
      id: 6,
      title: 'Small Businesses',
      description: 'Store documents and promotional materials easily, optimizing space utilization.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/small-businesses.svg',
        alt: 'Small Businesses'
      }
    }
  ]
}

export const evenOddList = {
  title: 'Our Different Storage Services',
  description: 'At ShipAndStorage, we offer a range of storage services designed to fit your needs',

  articles: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Secure and flexible storage for documents, inventory, or business equipment, with easy retrieval when needed.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/business-storage-solution.svg',
        alt: 'Business Storage Solution'
      },
      link: {
        text: 'Explore Business Storage',
        href: PUBLIC_MAIN_ROUTES.BUSINESS_STORAGE.href
      }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Perfect for those moving homes or offices, offering temporary storage for seamless transitions between locations.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/moving-storage-solution.svg',
        alt: 'Moving Storage Solution'
      },
      link: {
        text: 'Explore Moving Storage',
        href: PUBLIC_MAIN_ROUTES.MOVING_STORAGE_SOLUTIONS.href
      }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Secure storage and shipping solutions for personal luggage and boxes, ensuring that your belongings arrive safely when needed.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/luggage-and-box-shipping-services-solution.svg',
        alt: 'Luggage and Box Shipping Services'
      },
      link: {
        text: 'Explore Luggage & Box Shipping',
        href: PUBLIC_MAIN_ROUTES.LUGGAGE_BOX_SHIPPING_SERVICES.href
      }
    },
    {
      id: 4,
      title: 'Residential Storage Solution',
      description:
        'Our Residential Storage Solution provides secure, climate-controlled storage for your personal belongings during moves, renovations, or downsizing. ',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/residential-storage-solution.svg',
        alt: 'Residential Storage Solution'
      },
      link: {
        text: 'Explore Residential Storage',
        href: PUBLIC_MAIN_ROUTES.RESIDENTIAL_STORAGE.href
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose ShipAndStorage for Shipping and Storage Services',

  cards: [
    {
      id: 1,
      title: 'Customizable Shipping Solutions',
      description:
        'From a single luggage to an entire household, we cater to all shipping needs, including international shipping with our partners, FedEx and DHL.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/customizable-shipping-solutions.svg',
        alt: 'Customizable Shipping Solutions'
      }
    },
    {
      id: 2,
      title: 'Door-to-Door Convenience',
      description:
        'Skip the hassle of visiting storage centers—our team picks up and delivers your items right to your doorstep.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/door-to-door-convenience.svg',
        alt: 'Door-to-Door Convenience'
      }
    },
    {
      id: 3,
      title: 'Cost-Effective Storage',
      description: 'Pay only for the exact space your items require, ensuring you never overspend on unused storage.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-storage/cost-effective-storage.svg',
        alt: 'Cost-Effective Storage'
      }
    }
  ]
}

export const infoBannerSectionContent = {
  id: 1,
  title: 'Convenient Ship To Storage Solutions Available',
  description:
    'Fast, convenient ship to storage services tailored to your needs. Affordable and secure solutions to store and ship your belongings safely.',
  image: {
    src: '/images/v2/pages/landing-pages/ship-to-storage/convenient-ship-to-storage-solutions-available.svg',
    alt: 'Convenient Ship To Storage Solutions Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started' }
}

export const faqSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'At ShipAndStorage, we provide top-notch Shipping and Storage Services in partnership with trusted global carriers like FedEx, DHL, and UPS.',
  questions: [
    {
      id: 1,
      question: 'FedEx',
      answer:
        'Founded by Frederick W. Smith in 1971, FedEx has evolved from its humble beginnings of just 186 packages to become a global shipping leader. Operating a vast fleet of 696 aircraft and 215,000 vehicles, FedEx processes 16 million shipments daily to over 220 countries and territories. With more than 550,000 employees and over 5,000 centers worldwide, FedEx ensures reliable and timely deliveries.|||Disclaimer|||This page was last updated in September 2024 for reference purposes only. FedEx makes no warranties, express or implied, regarding the accuracy or completeness of the information provided. For more details, visit FedEx.com. FedEx® is a registered trademark. © 1995-2024 FedEx.'
    },

    {
      id: 2,
      question: 'DHL',
      answer:
        'DHL Express, a leading division of Deutsche Post DHL Group, is recognized for its exceptional international courier, parcel, and express mail services. Handling over 1.8 billion parcels annually, DHL plays a vital role in the global logistics market. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became a wholly-owned subsidiary of Deutsche Post in 2002 and operates in over 220 countries.|||Disclaimer:|||This page was last updated in September 2024 for reference purposes only. DHL makes no warranties regarding the accuracy of the information provided. For more details, visit DHL.com. DHL® is a registered trademark of DHL International GmbH. All rights reserved.'
    },
    {
      id: 3,
      question: 'UPS',
      answer:
        'Originally established as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, UPS re-branded as United Parcel Service (UPS) in 1919. Now one of the largest global shipping companies, UPS delivers 25 million packages daily. With a workforce of over 500,000 employees, UPS serves more than 220 countries and territories, providing unparalleled global reach.|||Disclaimer:|||This page was last updated in September 2024 for reference purposes only. UPS makes no warranties regarding the accuracy of the information provided. For more details, visit UPS.com. UPS® is a registered trademark of UPS Inc. All rights reserved.'
    }
  ]
}
